// extracted by mini-css-extract-plugin
export default {"labels":"Labels_labels__18MRB","labels--center":"Labels_labels--center__BrzqE"};